import { render, staticRenderFns } from "./ContentSlider.vue?vue&type=template&id=46b9ce3a&scoped=true&"
import script from "./ContentSlider.vue?vue&type=script&lang=js&"
export * from "./ContentSlider.vue?vue&type=script&lang=js&"
import style0 from "./ContentSlider.vue?vue&type=style&index=0&id=46b9ce3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9ce3a",
  null
  
)

export default component.exports